<h1>{{"gipUserForm" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</h1>
<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<div *ngIf="!showLoading">

    <app-formular [formBuilderInput]="modelInput" [formular]="formular" (action)="action($event)" [groupName]="groupName"></app-formular>

</div>